import { Seo } from "../components/Seo";
import { Reveal, Eyebrow } from "../components/Reveal";
import ProjectsGrid from "../components/sections/ProjectsGrid";
import CtaBand from "../components/sections/CtaBand";

const Projects = () => (
  <main data-testid="projects-page">
    <Seo
      title="Projects & Capabilities | Gas Station Renovation & Forecourt Repair | Petroline Services"
      description="Project capabilities of Petroline Services: gas station renovation, forecourt repairs, convenience store improvements, car-wash maintenance, electrical and mechanical work across Southern Ontario."
    />

    <section className="mx-auto max-w-7xl px-5 pb-16 pt-24 lg:px-8 lg:pt-32">
      <Reveal>
        <Eyebrow>Projects &amp; Capabilities</Eyebrow>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Commercial Projects. <span className="text-ember">Practical Results.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist md:text-lg">
          The categories of work Petroline Services takes on for petroleum retail and related
          commercial properties. Photography shown is representative of the types of commercial
          environments we service.
        </p>
      </Reveal>
    </section>

    <ProjectsGrid />
    <CtaBand title="Planning a renovation or repair project?" subtitle="Tell us about your property and what you need done — we'll discuss a practical approach." />
  </main>
);

export default Projects;
